  document.addEventListener('DOMContentLoaded', function() {
  const showMoreButton = document.querySelector('.js-show-more-products');
  const hiddenProducts = document.querySelectorAll('.js-product-item.hidden');

  if (showMoreButton && hiddenProducts.length > 0) {
  showMoreButton.addEventListener('click', function(e) {
  e.preventDefault();

  let counter = 0;
  for (const product of hiddenProducts) {
  if (product.classList.contains('hidden')) {
  product.classList.remove('hidden');
  counter++;

  if (counter >= 6) {
  break;
}
}
}

  const remainingHidden = document.querySelectorAll('.js-product-item.hidden').length;
  if (remainingHidden === 0) {
  showMoreButton.parentNode.classList.add('hidden');
}

  window.scrollBy({
  top: 200,
  behavior: 'smooth'
});
});
} else {
  if (showMoreButton) {
  showMoreButton.parentNode.classList.add('hidden');
}
}
});
